import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// WEBSITE IMAGES
import Website1 from "../assets/01.png";
import Website2 from "../assets/02.png";
import Website3 from "../assets/03.png";
import Website4 from "../assets/04.png";
import Website5 from "../assets/05.png";
import Website6 from "../assets/06.png";
import Website7 from "../assets/07.png";
import Website8 from "../assets/08.png";
import Website9 from "../assets/09.png";
import Website10 from "../assets/10.png";
import Website11 from "../assets/11.png";
import Website12 from "../assets/12.png";
import SEO1 from "../assets/SEO1.png";
import SEO2 from "../assets/SEO2.png";
import SEO3 from "../assets/SEO3.png";
import SEO4 from "../assets/SEO4.png";
import SEO5 from "../assets/SEO5.png";
import SEO6 from "../assets/SEO6.png";
import SEO7 from "../assets/SEO7.png";
import SEO10 from "../assets/SEO10.png";
import Reel1 from "../assets/reel1.mp4";
import Reel2 from "../assets/reel2.mp4";
import Reel3 from "../assets/reel3.mp4";
import Reel4 from "../assets/reel4.mp4";
import Reel5 from "../assets/reel5.mp4";

const CollageGrid = ({ className = "" }) => {
  const [activeFilter, setActiveFilter] = useState("allwork");
  const [openVideo, setOpenVideo] = useState(null);

  const IMAGES = {
    allwork: [
      "https://vyntradigital.com/wp-content/uploads/2025/08/Vibefit-.png",
      "https://vyntradigital.com/wp-content/uploads/2025/08/3.png",
      "https://vyntradigital.com/wp-content/uploads/2025/08/Untitled-1920-x-900-px-1536x720.png",
      "https://vyntradigital.com/wp-content/uploads/2025/08/Untitled-design-2-1536x720.png",
      "https://vyntradigital.com/wp-content/uploads/2025/08/2.png",
      "https://vyntradigital.com/wp-content/uploads/2025/08/4.png",
    ],

    websites: [
      Website1,
      Website2,
      Website3,
      Website4,
      Website5,
      Website6,
      Website7,
      Website8,
      Website9,
      Website10,
      Website11,
      Website12,
    ],
  };

  const otherCategories = {
    reels: [Reel1, Reel2, Reel3, Reel4, Reel5],

    seo: [SEO1, SEO2, SEO3, SEO4, SEO5, SEO6, SEO7, SEO10],
    design: [
      "https://vyntradigital.com/wp-content/uploads/2025/08/Vibefit-.png",
      "https://vyntradigital.com/wp-content/uploads/2025/08/3.png",
      "https://vyntradigital.com/wp-content/uploads/2025/08/2.png",
      "https://vyntradigital.com/wp-content/uploads/2025/08/4.png",
    ],
  };

  const currentImages =
    activeFilter === "websites"
      ? IMAGES.websites
      : activeFilter === "allwork"
      ? IMAGES.allwork
      : otherCategories[activeFilter];

  return (
    <div className={`w-full ${className}`}>
      {/* FILTER BAR */}
      <div className="flex flex-wrap justify-center gap-3 mb-12">
        {[
          { id: "allwork", label: "All Work", icon: "🔄" },
          { id: "websites", label: "Websites", icon: "🌐" },
          { id: "reels", label: "Reels", icon: "🎬" },
          { id: "seo", label: "SEO", icon: "📈" },
          { id: "design", label: "Design", icon: "🎨" },
        ].map((cat) => (
          <motion.button
            key={cat.id}
            whileHover={{ scale: 1.05 }}
            onClick={() => setActiveFilter(cat.id)}
            className={`px-6 py-2 flex items-center gap-2 rounded-full font-semibold text-sm ${
              activeFilter === cat.id
                ? "bg-orange-500 text-white"
                : "bg-gray-200 text-black hover:bg-gray-300"
            }`}
          >
            {cat.icon} {cat.label}
          </motion.button>
        ))}
      </div>

      {/* CONTENT */}
      <AnimatePresence mode="wait">
        <motion.div
          key={activeFilter}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {/* ⭐ KEEP ALL WORK UNCHANGED */}
          {activeFilter === "allwork" && (
            <div>
              {/* TOP ROW */}
              <div className="flex gap-5 mb-5 justify-center">
                <div className="w-[280px] h-[225px] rounded-2xl overflow-hidden">
                  <img
                    src={currentImages[0]}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-[280px] h-[225px] rounded-2xl overflow-hidden">
                  <img
                    src={currentImages[1]}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-[560px] h-[225px] rounded-2xl overflow-hidden">
                  <img
                    src={currentImages[2]}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* BOTTOM ROW */}
              <div className="flex gap-5 justify-center">
                <div className="w-[560px] h-[230px] rounded-2xl overflow-hidden">
                  <img
                    src={currentImages[3]}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="w-[280px] h-[230px] rounded-2xl overflow-hidden">
                  <img
                    src={currentImages[4]}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="w-[280px] h-[230px] rounded-2xl overflow-hidden">
                  <img
                    src={currentImages[5]}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          )}

          {/* ⭐ NEW — Websites: 12 Images in 4×3 Grid */}
          {activeFilter === "websites" && (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {currentImages.map((img, index) => (
                <div
                  key={index}
                  className="w-full h-full rounded-2xl overflow-hidden flex items-center justify-center"
                >
                  <img
                    alt=""
                    src={img}
                    className="w-full h-full object-contain"
                  />
                </div>
              ))}
            </div>
          )}
          {activeFilter === "seo" && (
            <div className="space-y-6">
              {/* Row 1 → 3 images */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {currentImages.slice(0, 3).map((img, index) => (
                  <div
                    key={index}
                    className="rounded-2xl overflow-hidden shadow-lg"
                  >
                    <img
                      alt=""
                      src={img}
                      className="w-full h-auto object-cover"
                    />
                  </div>
                ))}
              </div>

              {/* Row 2 → 3 images */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {currentImages.slice(3, 6).map((img, index) => (
                  <div
                    key={index}
                    className="rounded-2xl overflow-hidden shadow-lg"
                  >
                    <img
                      alt=""
                      src={img}
                      className="w-full h-auto object-cover"
                    />
                  </div>
                ))}
              </div>

              {/* Row 3 → 2 images */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6">
                {currentImages.slice(6, 8).map((img, index) => (
                  <div
                    key={index}
                    className="rounded-2xl overflow-hidden shadow-lg flex items-center"
                    style={{ maxHeight: "280px" }} // ⭐ controls the height
                  >
                    <img
                      alt=""
                      src={img}
                      className="w-full h-full object-contain"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
          {/* ⭐ DESIGN SECTION */}
          {/* ⭐ DESIGN SECTION */}
          {activeFilter === "design" && (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 justify-center">
              {currentImages.map((img, index) => (
                <div
                  key={index}
                  className="rounded-2xl overflow-hidden w-full h-full flex items-center justify-center"
                >
                  <img
                    alt=""
                    src={img}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          )}

          {/* ⭐ REELS SECTION — Local MP4 + Modal Video Player */}
          {activeFilter === "reels" && (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6 justify-center">
                {currentImages.map((videoSrc, index) => (
                  <div
                    key={index}
                    className="rounded-2xl overflow-hidden w-full h-full bg-black cursor-pointer"
                    onClick={() => setOpenVideo(videoSrc)}
                  >
                    {/* Autoplay preview (muted) */}
                    <video
                      src={videoSrc}
                      autoPlay
                      loop
                      muted
                      playsInline
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
              </div>
              {/* ⭐ POPUP MODAL WITH SOUND (Smaller Size) */}
              {/* ⭐ POPUP MODAL — SMALL INSTAGRAM VERTICAL REEL STYLE */}
              <AnimatePresence>
                {openVideo && (
                  <motion.div
                    className="fixed inset-0 bg-black/80 backdrop-blur-md flex items-center justify-center z-50 p-4"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={() => setOpenVideo(null)}
                  >
                    <motion.div
                      className="
          w-[300px] sm:w-[300px] 
          h-[500px] sm:h-[520px] 
          bg-black rounded-[28px] overflow-hidden
          shadow-2xl
          flex items-center justify-center
        "
                      initial={{ scale: 0.7, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      exit={{ scale: 0.7, opacity: 0 }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <video
                        src={openVideo}
                        controls
                        autoPlay
                        className="w-full h-full object-cover rounded-[28px]"
                      />
                    </motion.div>

                    {/* Close Button */}
                    <button
                      onClick={() => setOpenVideo(null)}
                      className="absolute bottom-8 text-white bg-red-600 px-6 py-2 rounded-full font-semibold shadow-lg"
                    >
                      Close
                    </button>
                  </motion.div>
                )}
              </AnimatePresence>
            </>
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default CollageGrid;
